export const DescriptionFormater = (description: string) => {
  const sentences = description.split("\n");
  const indexOfFeatures = sentences.indexOf("Features:");
  return sentences
    .map((sentence, id) => {
      if (sentence !== "Features:") {
        if (indexOfFeatures < id) {
          return `- ${sentence}<br />`;
        } else {
          return `${sentence}<br />`;
        }
      } else {
        return `<br/><b>${sentence}</b><br />`;
      }
    })
    .join("");
};

export const DescriptionHomeFormater = (description: string) => {
  const sentences = description.split("\n");
  return sentences.length > 0 ? sentences[0] : "";
};

export const AttachSuffixToRank = (rank: number) => {
  const lastTwoDigits = rank % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${rank}th`;

  const lastDigit = rank % 10;
  switch (lastDigit) {
    case 1:
      return `${rank}st`;
    case 2:
      return `${rank}nd`;
    case 3:
      return `${rank}rd`;
    default:
      return `${rank}th`;
  }
};

export const formatScore = (score: number) => {
  return score.toLocaleString();
};
